import React, { useContext, useEffect, useRef, useState } from "react";
import "./partRequest.css";
import { NavBar } from "../../../../components/NavBar/NavBar";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Link,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Sorting } from "../../../../components/Lists/Sorting";
import { PartRequestItem } from "./PartRequestItem/PartRequestItem";
import { Dropdowns } from "../../../../components/Dropdowns/Dropdowns";
import { dropdownConfig } from "../../../../services/dropdownsConfigService";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { environment } from "../../../../environments/environment";
import Skeleton from "react-loading-skeleton";
import {
  PartRequestContext,
  PartRequestProvider,
} from "../../context/PartRequestContext";
import { PartRequestTabularView } from "./PartRequestTabularView/PartRequestTabularView";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import {
  getEmployeesByLocation,
  getPartRequestListHierarchycal,
} from "../../Services/partRequestService";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { useDispatch } from "react-redux";
import {
  addTab,
  clearActiveTab,
  closeTab,
} from "../../../../redux/features/TabsManager/tabSlice";
import { Radios } from "../../../../components/RadioGroup/Radios";
import {
  DropdownsContext,
  DropdownsProvider,
} from "../../../../contexts/DropdownsContext";
import Input from "../../../../components/Inputs/Input";
import { DateRangeComponent } from "../../../../components/DateRangeComponent/DateRangeComponent";
import { PermissionsProvider } from "../../../../contexts/PermissionsContext";
import { getPermissions } from "../../../../services/authService";
import { use } from "react";
import {
  createFiltersConfig,
  FiltersManager,
} from "../../../../components/FiltersManager/FiltersManager";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { SortingHeader } from "../../../../components/Sorting/SortingHeader";
import { SortingButton } from "../../../../components/Sorting/SortingButton";
import { useNewPartRequestContext } from "../../context/NewPartRequestContext";
const dropdownNames = {
  79: "rackId",
};
const ButtonCreateOrEmit = ({ value }) => {
  const { errorMsg } = useSnackBar();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [issueDetailToSelect, setIssueDetailToSelect] = useState(2);
  const { partsRequestToIssue, issueParts, typeRequestTab } =
    useContext(PartRequestContext);
  const [cantToIssue, setCantToIssue] = useState(0);
  const [rackDrop, setRackDrop] = useState(null);
  const [employeeDrop, setEmployeeDrop] = useState(null);
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [forceDependency, setForceDependency] = useState([]);
  const [dataEmployeeDrop, setDataEmployeeDrop] = useState([]);
  const [employeeSelected, setEmployeeSelected] = useState(null);
  const hideFieldsWhenDisabled = new Set(["Rack"]);
  const didMount = useRef(false);
  const dropdownIds = [79];
  const {
    dropdownsData,
    setDropdownsData,
    dropdownDefaultOptions,
    setDropdownIds,
  } = useContext(DropdownsContext);

  useEffect(() => {
    setCantToIssue(partsRequestToIssue.length);
    if (partsRequestToIssue && partsRequestToIssue.length > 0) {
      setDropdownIds(dropdownIds);
      setForceDependency([
        {
          id: 25,
          parentSqlstatementColumnName: "id",
          childDropdownId: 79,
          childSqlstatementColumnName: "site_id",
          childSqlstatementParameterName: "siteId",
          contextId: 1,
          value: [partsRequestToIssue[0].site_id],
        },
      ]);
      getEmployeesDropdownConfig();
    } else {
      setEmployeeDrop(null);
      setRackDrop(null);
    }
  }, [partsRequestToIssue]);
  useEffect(() => {
    setRackDrop(null);
    setEmployeeSelected(null);
    if (partsRequestToIssue && partsRequestToIssue.length > 0) {
      setForceDependency([
        {
          id: 25,
          parentSqlstatementColumnName: "id",
          childDropdownId: 79,
          childSqlstatementColumnName: "site_id",
          childSqlstatementParameterName: "siteId",
          contextId: 1,
          value: [partsRequestToIssue[0].site_id],
        },
      ]);
      getEmployeesDropdownConfig();
    }
  }, [issueDetailToSelect]);
  const getEmployeesDropdownConfig = async () => {
    let dropdownId = 85;
    const request = await dropdownConfig(dropdownId);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      const data = await getEmployeesByLocation(26);
      setDataEmployeeDrop(data.data.load);
      setEmployeeDrop(request.data.load);
    }
  };

  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) setDisplayDropdown(true);
  }, [dropdownsData]);

  function generateUUID() {
    return crypto.randomUUID();
  }
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    getEmployeesDropdownConfig();
    setTimeout(() => {
      dispatch(
        addTab({
          icon: "icon-part_request_icon",
          color: "#6AC24F ",
          path: "/store/part-request-management",
          title: "Part Request Management",
          isPinned: false,
          componentKey: "PartRequest",
          id: 15,
          isModule: false,
          date: generateUUID(),
        })
      );
    }, 500);
  }, []);

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };

  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };

  const newPartRequest = async () => {
    const basePath = environment.basePath;

    dispatch(clearActiveTab("/store/part-request-management"));
    // dispatch(closeTab("/store/part-request-management"))

    dispatch(
      addTab({
        icon: "icon-part_request_icon",
        color: "#6ac24f",
        path: "/store/new-part-request",
        title: "New Part Request",
        isPinned: false,
        componentKey: "NewPartRequest",
        id: -1,
        isModule: false,
        date: generateUUID(),
      })
    );
    navigate(basePath + "/store/new-part-request");
  };
  const getEmployeeSelection = (selectedValues) => {
    setEmployeeSelected(selectedValues.id);
    setRackDrop(null);
  };
  const getRackSelection = (selectedValues) => {
    setRackDrop(selectedValues.id);
    setEmployeeSelected(null);
  };

  useEffect(() => {
    if (typeRequestTab == "Transfer") {
      setIssueDetailToSelect(1);
    }
  }, [typeRequestTab]);
  return value == 0 ? (
    <button className="part-request-button" onClick={newPartRequest}>
      + New Part Request
    </button>
  ) : (
    <div style={{ display: "flex", gap: "0.5rem" }}>
      {cantToIssue > 0 && (
        <>
          <div className="issue-detail">
            <Radios
              name="miGrupo"
              items={
                typeRequestTab == "Workpackage"
                  ? [
                      { label: "Issue to Employee", value: 2 },
                      { label: "Issue to Rack", value: 1 },
                    ]
                  : typeRequestTab == "Transfer"
                  ? [
                      // { label: "Issue to Employee", value: 2 },
                      { label: "Transfer to Rack", value: 1 },
                    ]
                  : null
              }
              value={issueDetailToSelect}
              onChange={(val) => setIssueDetailToSelect(val)}
            />
          </div>
          <div style={{ width: "11vw" }}>
            {issueDetailToSelect == 1 ? (
              displayDropdown ? (
                <Dropdowns
                  context={{
                    dropdownsData,
                    setDropdownsData,
                    setDropdownIds,
                    dropdownDefaultOptions,
                  }}
                  required={true}
                  hideLabel={true}
                  placeholder={true}
                  forceDependency={forceDependency}
                  updateDropdown={updateDropdown}
                  resetDropdownsReload={resetDropdownsReload}
                  hideWhenDisabled={hideFieldsWhenDisabled.has(
                    dropdownNames[79]
                  )}
                  key={79}
                  onOptionSelect={(value, data) =>
                    getRackSelection(value, dropdownNames[79], data)
                  }
                  showPagination={false}
                  data={dropdownsData.find((e) => e.id === 79)}
                ></Dropdowns>
              ) : (
                <Skeleton height="2rem" width="80%" />
              ) //sites
            ) : employeeDrop && typeRequestTab == "Workpackage" ? (
              <Dropdowns
                onOptionSelect={getEmployeeSelection}
                updateDropdown={updateDropdown}
                resetDropdownsReload={resetDropdownsReload}
                staticDataColumnPreselection={"id"}
                isStatic={true}
                hideLabel={true}
                placeholder={true}
                staticData={dataEmployeeDrop}
                data={employeeDrop}
                required={true}
              ></Dropdowns>
            ) : (
              <Skeleton height="2rem" width="100%" />
            )}
          </div>
        </>
      )}
      <button
        className={`part-request-button-issue ${
          !cantToIssue ||
          (issueDetailToSelect == 1 && !rackDrop) ||
          (issueDetailToSelect == 2) & !employeeSelected
            ? "disabled"
            : ""
        }`}
        onClick={() => issueParts(rackDrop, employeeSelected)}
      >
        <div className="left-side">
          <i className="icon-issue"></i>
          <p>
            {typeRequestTab == "Workpackage"
              ? "Part Issue"
              : typeRequestTab == "Transfer"
              ? "Transfer"
              : ""}{" "}
          </p>{" "}
        </div>
        {cantToIssue > 0 && (
          <div className="cant-to-issue">
            <p>PN</p>
            <div>{cantToIssue}</div>
          </div>
        )}
      </button>
    </div>
  );
};
const SearchBarContainer = () => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const { onSearch } = useContext(PartRequestContext);
  const didMount = useRef(false);
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 1000); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    onSearch(debouncedValue);
  }, [debouncedValue]);
  return <input placeholder="Search" onChange={handleChange} />;
};

const ToggleViewButtons = ({ tabView, handlerTabsOptions }) => {
  const { setTabIndex } = useContext(PartRequestContext);
  const setTabView = (value) => {
    setTabIndex(value);
    handlerTabsOptions(value);
  };
  return (
    <div className="view-options-part-request-stores">
      <Tooltip className="custom-tooltip" title={"Hierarchy view"} arrow>
        <button
          className={`toogle-view ${tabView == 0 ? "active-toogle" : ""}`}
          onClick={() => setTabView(0)}
        >
          <i className="icon-hierarchy-view"></i>
        </button>
      </Tooltip>
      <Tooltip className="custom-tooltip" title={"Tabular view"} arrow>
        <button
          className={`toogle-view ${tabView > 0 ? "active-toogle" : ""}`}
          onClick={() => setTabView(1)}
        >
          <i className="icon-tabular-view"></i>
        </button>
      </Tooltip>
    </div>
  );
};

export const PartRequest = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { dataFromPrns } = location.state || {};
  const [partList, setPartList] = useState([]);
  const [itemPartRequestOpened, setItemPartRequestOpened] = useState(null);
  const [viewFilters, setViewFilters] = useState(false);
  const [value, setValue] = React.useState(0);
  const debounceRef = useRef(null);
  const sectionPartListRef = useRef(null);
  const [prnListBody, setPrnListBody] = useState(() => {
    let companies = localStorage.getItem("u_companies");
    let companiesId = [];

    if (companies) {
      try {
        const parsedCompanies = JSON.parse(companies);
        if (Array.isArray(parsedCompanies)) {
          companiesId = parsedCompanies.map((e) => e.id);
        }
      } catch (error) {
        console.error("Error parsing companies from localStorage", error);
      }
    }

    return [
      {
        columnName: "company_id",
        value: companiesId,
      },
    ];
  });
  let contexthighlightstyle =
    "background-color: var(--blue-500); border: solid 1px var(--green-25);";
  const mockOptions = {
    "parts-configuration": {
      label: "Part Issue",
      icon: "icon-issue",
      callback: (part) => {
        dispatch(clearActiveTab());
        navigate("/secure/store/inventory-transaction", {
          state: { data: part, type: "issue" },
        });
      },
    },
  };
  // dropdowns states
  const [requestNumDrop, setRequestNumDrop] = useState(null);
  const [FNDDrop, setFNDDrop] = useState(null);
  const [locationDrop, setLocationDrop] = useState(null);
  const [locationDropHierarchy, setLocationDropHierarchy] = useState(null);

  const [rackDrop, setRackDrop] = useState(null);
  const [aircraftDrop, setAircraftDrop] = useState(null);
  const [WPDrop, setWPDrop] = useState(null);
  const [taskCardDrop, setTaskCardDrop] = useState(null);
  const [partNumDrop, setPartNumDrop] = useState(null);
  const [companyDrop, setCompanyDrop] = useState(null);
  const [customerDrop, setCustomerDrop] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, SetPageSize] = useState(20);
  const [maxPages, setMaxPages] = useState(0);
  const [sorting, setSorting] = useState("id");
  const dispatch = useDispatch();
  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        navigate("/secure/customdashboard");
      }}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        navigate("/secure/store");
      }}
    >
      Stores
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      Part Request
    </Link>,
  ];
  const [companyDropData, setCompanyDropData] = useState([]);

  // handle dropdowns filter selection

  const [requestNumberSelected, setRequestNumberSelected] = useState([]);
  const [locationSelected, setLocationSelected] = useState([]);
  const [aircraftSelected, setAircraftSelected] = useState([]);
  const [WPSelected, setWPSelected] = useState([]);
  const [FNDSelected, setFNDSelected] = useState([]);
  const [TCSelected, setTCSelected] = useState([]);
  const [partNumberSelected, setPartNumberSelected] = useState([]);
  // const [dateRequiredSelected, setDateRequiredSelected] = useState(null);
  // const [dateRequestSelected, setDateRequestedSelected] = useState(null);

  const [dateRangeSelected, setDateRangeSelected] = useState(null);
  const [dateRequestedRangeSelected, setDateRequestedRangeSelected] =
    useState(null);
  const [resetDateRange, setResetDateRange] = useState(0);

  const [companySelected, setCompanySelected] = useState([]);
  const [customerSelected, setCustomerSelected] = useState([]);
  const [statusSelected, setStatusSelected] = useState(["all"]);
  const allOptions = [
    "all",
    "Draft",
    "Posted",
    "partially issued",
    "in transfer",
    "issued",
    "cancel",
  ];
  const individualOptions = allOptions.filter((opt) => opt !== "all");

  // handle dropdowns preselection states
  const [requestNumberPreselected, setRequestNumberPreselected] =
    useState(null);
  const [locationPreselected, setLocationPreselected] = useState(null);
  const [aircraftPreselected, setAircraftPreselected] = useState();
  const [WPPreselected, setWPPreselected] = useState();
  const [FNDPreselected, setFNDPreselected] = useState();
  const [TCPreselected, setTCPreselected] = useState();
  const [partNumberPreselected, setPartNumberPreselected] = useState();
  const [companyPreselected, setCompanyPreselected] = useState();
  const [customerPreselected, setCustomerPreselected] = useState();
  const [hasPermissionsToCreate, setHasPermissionsToCreate] = useState(false);
  const [typeRequestTab, setTypeRequestTab] = useState("Workpackage");
  const [countWPRequest, setCountWPRequest] = useState(0);
  const [countTransferRequest, setCountTransferRequest] = useState(0);
  const [sortingColumns, setSortingColumns] = useState({
    id: "PRN",
    wp: "WP",
    location_id: "Location",
    tail_number: "Aircraft",
    date_required: "Date Required",
    part_request_type: "PRN Type",
  });

  const [requestNumberOptionToDelete, setRequestNumberOptionToDelete] =
    useState(null);
  const [locationOptionToDelete, setLocationOptionToDelete] = useState(null);
  const [aircraftOptionToDelete, setAircraftOptionToDelete] = useState(null);
  const [wpOptionToDelete, setWPOptionToDelete] = useState(null);
  const [fndOptionToDelete, setFNDOptionToDelete] = useState(null);
  const [tcOptionToDelete, setTCOptionToDelete] = useState(null);
  const [partNumberOptionToDelete, setPartNumberOptionToDelete] =
    useState(null);
  const [companyOptionToDelete, setCompanyOptionToDelete] = useState(null);
  const [customerOptionToDelete, setCustomerOptionToDelete] = useState(null);
  const [statusOptionToDelete, setStatusOptionToDelete] = useState(null);
  const { shouldReload, clearNotification } = useNewPartRequestContext();
  const [visualizeSkeletonLoading, setVisualizeSkeleton] = useState(true);

  const didMount = useRef(false);

  //functions

  const getCompanyFilter = () => {
    const companies = JSON.parse(localStorage.getItem("u_companies")) || [];
    return {
      columnName: "company_id",
      value: companies.map((e) => e.id),
    };
  };

  const buildPrnListBody = (filters = []) => {
    return [getCompanyFilter(), ...filters.filter(Boolean)];
  };

  const handleChangeToggle = (newValue) => {
    setValue(newValue);
  };

  const getDropdownConfigPartNum = async () => {
    let id = 1;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPartNumDrop(request.data.load);
    }
  };

  const getDropdownConfigLocations = async () => {
    let id = 87;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setLocationDropHierarchy(request.data.load);
    }
  };

  const getDropdownCongigRacks = async () => {
    let id = 17;
    const forceDependency = [
      [
        {
          id: 25,
          parentSqlstatementColumnName: "id",
          childDropdownId: 19,
          childSqlstatementColumnName: "site_id",
          childSqlstatementParameterName: "siteId",
          contextId: 1,
          value: [1],
        },
      ],
    ];
    const request = await dropdownConfig(id, "", forceDependency);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setLocationDrop(request.data.load);
    }
  };

  const getDropdownConfigAircraft = async () => {
    let id = 88;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setAircraftDrop(request.data.load);
    }
  };

  const getDropdownConfigWP = async () => {
    let id = 93;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setWPDrop(request.data.load);
    }
  };

  const getDropdownConfigRequestNum = async () => {
    let id = 57;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setRequestNumDrop(request.data.load);
    }
  };

  const getDropdownConfigFND = async () => {
    let id = 89;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setFNDDrop(request.data.load);
    }
  };

  const getDropdownConfigTaskCard = async () => {
    let id = 90;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setTaskCardDrop(request.data.load);
    }
  };

  const getDropdownConfigCompany = async () => {
    let id = 91;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCompanyDrop(request.data.load);
    }
  };

  const getDropdownConfigCustomer = async () => {
    let id = 92;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCustomerDrop(request.data.load);
    }
  };

  const getAllDropdowns = async () => {
    const results = await Promise.all([
      getDropdownConfigPartNum(),
      getDropdownConfigLocations(),
      getDropdownConfigAircraft(),
      getDropdownConfigWP(),
      getDropdownConfigRequestNum(),
      getDropdownConfigFND(),
      getDropdownConfigTaskCard(),
      getDropdownConfigCompany(),
      getDropdownConfigCustomer(),
      getDropdownCongigRacks(),
    ]);

    return results;
  };

  const getSortingChange = (data) => {
    setSorting(data);
  };

  const getItemOpened = (itemNum) => {
    setItemPartRequestOpened(itemNum);
  };

  const getPartRequest = async (
    p = 0,
    pS = pageSize,
    search = "",
    isScroll = false,
    body = prnListBody
  ) => {
    setLoading(true);
    try {
      let request = await getPartRequestListHierarchycal(
        p,
        pS,
        sorting,
        search,
        body,
        typeRequestTab
      );

      if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
        setMaxPages(request.data.totalPages);
        setCountWPRequest(request.data.auxiliarInformation.countView0);
        setCountTransferRequest(request.data.auxiliarInformation.countView1);
        if (isScroll) {
          setPartList((prevList) => {
            return [...prevList, ...request.data.load];
          });
          setPage((prevPage) => {
            return prevPage + 1;
          });
        } else {
          setPartList(request.data.load);
          setPage(1);
        }
      }
    } catch (error) {
      throw new Error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    const section = sectionPartListRef.current;
    if (section) {
      const { scrollTop, scrollHeight, clientHeight } = section;
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        getMorePartRequest();
      }
    }
  };

  const getMorePartRequest = () => {
    if (loading || page >= maxPages) {
      return;
    }
    setVisualizeSkeleton(false);
    getPartRequest(page, pageSize, "", true, prnListBody);
  };

  const handleSearchOfPRN = (e) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      // const bodyOfSearch = [];
    setVisualizeSkeleton(true);

      getPartRequest(0, pageSize, e, false, prnListBody);
    }, environment.debounceTime);
  };

  const selectStatusFilter = (e) => {
    const value = e.target.value;

    if (value === "all") {
      // Si hacen click en "All", seleccionar/deseleccionar todo
      setStatusSelected(statusSelected.includes("all") ? [] : allOptions);
    } else {
      setStatusSelected((prev) => {
        if (prev.includes("all")) {
          return individualOptions.filter((opt) => opt !== value);
        } else {
          const newSelection = prev.includes(value)
            ? prev.filter((item) => item !== value)
            : [...prev, value];

          return individualOptions.every((opt) => newSelection.includes(opt))
            ? allOptions
            : newSelection;
        }
      });
    }
  };

  const getPermissionsToCreate = async () => {
    let request = await getPermissions(15);

    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setHasPermissionsToCreate(
        request.data.load.some((action) => action.key === "create")
      );
    }
  };

  useEffect(() => {
    const section = sectionPartListRef.current;
    if (section) {
      section.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (section) {
        section.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  useEffect(() => {
    if (
      viewFilters &&
      !requestNumDrop &&
      !locationDrop &&
      !aircraftDrop &&
      !WPDrop &&
      !FNDDrop &&
      !taskCardDrop &&
      !partNumDrop &&
      !companyDrop &&
      !customerDrop
    ) {
      getAllDropdowns();
    }
  }, [viewFilters]);

  const formatEndOfDay = (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    date.setHours(23, 59, 59, 999);
    return date.toISOString();
  };

  useEffect(() => {
    if (viewFilters) {
      const hasFiltersChanged =
        requestNumberSelected.length > 0 ||
        locationSelected.length > 0 ||
        aircraftSelected.length > 0 ||
        WPSelected.length > 0 ||
        FNDSelected.length > 0 ||
        TCSelected.length > 0 ||
        partNumberSelected.length > 0 ||
        dateRangeSelected ||
        dateRequestedRangeSelected ||
        companySelected.length > 0 ||
        customerSelected.length > 0 ||
        statusSelected.length > 0;

      if (hasFiltersChanged) {
        const processDateRange = (dateRange) => {
          if (!dateRange?.startDate && !dateRange?.endDate) return undefined;

          return {
            ...dateRange,
            endDate: formatEndOfDay(dateRange.endDate),
          };
        };

        setPrnListBody(
          buildPrnListBody(
            [
              statusSelected.length > 0 && {
                columnName: "status",
                value:
                  statusSelected == "all"
                    ? [
                        "draft",
                        "posted",
                        "partially issued",
                        "in transfer",
                        "issued",
                        "cancel",
                      ]
                    : statusSelected,
              },
              requestNumberSelected.length > 0 && {
                columnName: "id",
                value: requestNumberSelected.map((e) => e.id),
              },
              locationSelected.length > 0 && {
                columnName: "location_id",
                value: locationSelected.map((e) => e.id),
              },
              aircraftSelected.length > 0 && {
                columnName: "tail_number",
                value: aircraftSelected.map((e) => e.tail_number),
              },
              WPSelected.length > 0 && {
                columnName: "wp",
                value: WPSelected.map((e) => e.id),
              },
              // FNDSelected.length > 0 && {
              //   columnName: "fnd",
              //   value: FNDSelected.map((e) => e.id),
              // },
              TCSelected.length > 0 && {
                columnName: "taskcard",
                value: TCSelected.map((e) => e.id),
              },
              partNumberSelected.length > 0 && {
                columnName: "part_number_list",
                value: partNumberSelected.map((e) => e.id),
                isListString: true,
              },
              dateRangeSelected?.startDate || dateRangeSelected?.endDate
                ? {
                    columnName: "date_required",
                    value: processDateRange(dateRangeSelected),
                  }
                : undefined,
              dateRequestedRangeSelected?.startDate ||
              dateRequestedRangeSelected?.endDate
                ? {
                    columnName: "date_required",
                    value: processDateRange(dateRequestedRangeSelected),
                  }
                : undefined,
              // companySelected.length > 0 && {
              //   columnName: "accountId",
              //   value: companySelected.map((e) => e.id),
              // },
              customerSelected.length > 0 && {
                columnName: "customer",
                value: customerSelected.map((e) => e.id),
              },
            ].filter(Boolean)
          )
        );

        let companies = localStorage.getItem("u_companies");
        let companiesId = [];

        if (companies) {
          try {
            const parsedCompanies = JSON.parse(companies);
            if (Array.isArray(parsedCompanies)) {
              companiesId = parsedCompanies.map((e) => e.id);
            }
          } catch (error) {
            console.error("Error parsing companies from localStorage", error);
          }
        }

        let body = [
          {
            columnName: "company_id",
            value: companiesId,
          },
          statusSelected.length > 0 && {
            columnName: "status",
            value:
              statusSelected == "all"
                ? [
                    "draft",
                    "posted",
                    "partially issued",
                    "in transfer",
                    "issued",
                    "cancel",
                  ]
                : statusSelected,
          },
          requestNumberSelected.length > 0 && {
            columnName: "id",
            value: requestNumberSelected.map((e) => e.id),
          },
          locationSelected.length > 0 && {
            columnName: "location_id",
            value: locationSelected.map((e) => e.id),
          },
          aircraftSelected.length > 0 && {
            columnName: "tail_number",
            value: aircraftSelected.map((e) => e.tail_number),
          },
          WPSelected.length > 0 && {
            columnName: "wp",
            value: WPSelected.map((e) => e.id),
          },
          // FNDSelected.length > 0 && {
          //   columnName: "fnd",
          //   value: FNDSelected.map((e) => e.id),
          // },
          TCSelected.length > 0 && {
            columnName: "taskcard",
            value: TCSelected.map((e) => e.id),
          },
          partNumberSelected.length > 0 && {
            columnName: "part_number_list",
            value: partNumberSelected.map((e) => e.id),
            isListString: true,
          },
          dateRangeSelected?.startDate || dateRangeSelected?.endDate
            ? {
                columnName: "date_required",
                value: processDateRange(dateRangeSelected),
              }
            : undefined,
          dateRequestedRangeSelected?.startDate ||
          dateRequestedRangeSelected?.endDate
            ? {
                columnName: "date_required",
                value: processDateRange(dateRequestedRangeSelected),
              }
            : undefined,
          // companySelected.length > 0 && {
          //   columnName: "company_id",
          //   value: companySelected.map((e) => e.id),
          // },
          customerSelected.length > 0 && {
            columnName: "customer",
            value: customerSelected.map((e) => e.id),
          },
        ].filter(Boolean);
        setVisualizeSkeleton(true);

        getPartRequest(0, pageSize, "", false, body);
      }
    }
  }, [
    requestNumberSelected,
    locationSelected,
    aircraftSelected,
    WPSelected,
    // FNDSelected,
    // TCSelected,
    partNumberSelected,
    dateRangeSelected,
    dateRequestedRangeSelected,
    companySelected,
    customerSelected,
    statusSelected,
  ]);
  const didMountValue = useRef(false);
  useEffect(() => {
    if (!didMountValue.current) {
      didMountValue.current = true;
      return;
    }
    if (value == 0) {
      setVisualizeSkeleton(true);
      getPartRequest(0, pageSize, "", false, prnListBody);
    }
  }, [value]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    setCompanyDropData(() => JSON.parse(localStorage.getItem("u_companies")));
    getPermissionsToCreate();
    setVisualizeSkeleton(true);

    getPartRequest(0, pageSize, "", false, prnListBody);
    if (typeRequestTab == "Workpackage") {
      setSortingColumns({
        id: "PRN",
        wp: "WP",
        location: "Location",
        tail_number: "Aircraft",
        date_required: "Date Required",
        part_request_type: "PRN Type",
        company_name: "Company",
      });
    } else if (typeRequestTab == "Transfer") {
      setSortingColumns({
        id: "PRN",
        wp: "WP",
        origin_location: "Origin Location",
        location: "Destination Location",
        tail_number: "Aircraft",
        date_required: "Date Required",
        part_request_type: "PRN Type",
        company_name: "company",
      });
    }
  }, [sorting, typeRequestTab]);

  useEffect(() => {
    if (dataFromPrns && dataFromPrns.length > 0) {
      setTypeRequestTab("Transfer");
      setPrnListBody(
        buildPrnListBody([
          {
            columnName: "id",
            value: dataFromPrns,
          },
        ])
      );
    }
  }, [dataFromPrns]);

  useEffect(() => {
    if (shouldReload) {
      setVisualizeSkeleton(true);
      getPartRequest(0, pageSize, "", false, prnListBody);

      clearNotification();
    }
  }, [shouldReload]);

  const clearFilters = () => {
    setStatusSelected(["all"]);
    setRequestNumberSelected([]);
    setLocationSelected([]);
    setAircraftSelected([]);
    setWPSelected([]);
    setFNDSelected([]);
    setTCSelected([]);
    setPartNumberSelected([]);
    // setDateRequiredSelected(null);
    // setDateRequestedSelected(null);

    setDateRangeSelected(null);
    setDateRequestedRangeSelected(null);
    setResetDateRange((prev) => prev + 1);
    setCompanySelected([]);
    setCustomerSelected([]);

    setRequestNumberPreselected(null);
    setLocationPreselected(null);
    setAircraftPreselected(null);
    setWPPreselected(null);
    setFNDPreselected(null);
    setTCPreselected(null);
    setPartNumberPreselected(null);
    setCompanyPreselected(null);
    setCustomerPreselected(null);

    setPrnListBody(buildPrnListBody());
  };

  const handleDateRange = (range) => {
    setDateRangeSelected(range);
  };
  const handleDateRequestedRange = (range) => {
    setDateRequestedRangeSelected(range);
  };

  function generateUUID() {
    return crypto.randomUUID();
  }

  const goBackDataObj = {
    icon: "icon-store_module_icon",
    color: "#EB9090",
    path: "/store",
    title: "Store",
    isPinned: false,
    componentKey: "Stores",
    id: -1,
    isModule: true,
    date: generateUUID(),
  };

  // funtions to filters manager

  const rawFilters = {
    id: {
      label: "PRN",
      selected: requestNumberSelected,
      setSelected: setRequestNumberSelected,
      setPreselect: setRequestNumberPreselected,
      setToDelete: setRequestNumberOptionToDelete,
      getDisplay: (item) => item?.id,
    },
    location_id: {
      label: "Location",
      selected: locationSelected,
      setSelected: setLocationSelected,
      setPreselect: setLocationPreselected,
      setToDelete: setLocationOptionToDelete,
      getDisplay: (item) => item?.code,
    },
    tail_number: {
      label: "Aircraft",
      selected: aircraftSelected,
      setSelected: setAircraftSelected,
      setPreselect: setAircraftPreselected,
      setToDelete: setAircraftOptionToDelete,
      getDisplay: (item) => item?.tail_number,
    },
    wp: {
      label: "WP",
      selected: WPSelected,
      setSelected: setWPSelected,
      setPreselect: setWPPreselected,
      setToDelete: setWPOptionToDelete,
      getDisplay: (item) => item?.id,
    },
    // fnd: {
    //   label: "FND",
    //   selected: FNDSelected,
    //   setSelected: setFNDSelected,
    //   setPreselect: setFNDPreselected,
    //   setToDelete: setFNDOptionToDelete,
    //   getDisplay: (item) => item?.id,
    // },
    tc: {
      label: "TC",
      selected: TCSelected,
      setSelected: setTCSelected,
      setPreselect: setTCPreselected,
      setToDelete: setTCOptionToDelete,
      getDisplay: (item) => item?.id,
    },
    part_number_list: {
      label: "Part Numbers",
      selected: partNumberSelected,
      setSelected: setPartNumberSelected,
      setPreselect: setPartNumberPreselected,
      setToDelete: setPartNumberOptionToDelete,
      getDisplay: (item) => item?.part_number,
    },
    company_id: {
      label: "Companies",
      selected: companySelected,
      setSelected: setCompanySelected,
      setPreselect: setCompanyPreselected,
      setToDelete: setCompanyOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    customer: {
      label: "Customer",
      selected: customerSelected,
      setSelected: setCustomerSelected,
      setPreselect: setCustomerPreselected,
      setToDelete: setCustomerOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    status: {
      label: "Status",
      selected: statusSelected,
      setSelected: setStatusSelected,
      setToDelete: setStatusOptionToDelete,
      getDisplay: (item) => item,
    },
    date_required: {
      label: "Date Required",
      isDate: true,
      clear: () => setDateRangeSelected(null),
    },
    date_requested: {
      label: "Date Requested",
      isDate: true,
      clear: () => setDateRequestedRangeSelected([]),
    },
  };

  const filtersConfig = createFiltersConfig(
    rawFilters,
    setPrnListBody,
    getPartRequest,
    [0, pageSize, "", false]
  );

  const handleFiltersSortingChange = (fullSelectedMap) => {
    setPrnListBody((prevBody) => {
      const updatedBody = [...prevBody];

      Object.entries(fullSelectedMap).forEach(([columnName, fullSelected]) => {
        const existingIndex = updatedBody.findIndex(
          (f) => f.columnName === columnName
        );

        if (!fullSelected || fullSelected.length === 0) {
          if (existingIndex !== -1) {
            updatedBody.splice(existingIndex, 1);
          }

          if (columnName === "id") {
            setRequestNumberSelected([]);
          } else if (columnName === "wp") {
            setWPSelected([]);
          } else if (columnName === "location") {
            setLocationSelected([]);
          } else if (columnName === "tail_number") {
            setAircraftSelected([]);
          }

          return;
        }

        const valuesOnly = fullSelected.map(
          (item) => item.tail_number || item.id || item
        );

        if (existingIndex !== -1) {
          updatedBody[existingIndex].value = valuesOnly;
        } else {
          updatedBody.push({ columnName, value: valuesOnly });
        }

        if (columnName === "id") {
          setRequestNumberSelected(fullSelected);
        } else if (columnName === "wp") {
          setWPSelected(fullSelected);
        } else if (columnName === "location") {
          setLocationSelected(fullSelected);
        } else if (columnName === "tail_number") {
          setAircraftSelected(fullSelected);
        }
      });
      setVisualizeSkeleton(true);

      getPartRequest(0, pageSize, "", false, updatedBody);
      return updatedBody;
    });
  };

  const [tcParameters, setTCParameters] = useState(null);
  useEffect(() => {
    setTCParameters(() => {
      return [
        {
          columnName: "wpId",
          value: [WPSelected.id],
        },
      ];
    });
  }, [WPSelected]);
  return (
    <SortingProvider
      onOrderChange={getSortingChange}
      properties={sortingColumns}
      columnFilterProperties={{
        id: 57,
        wp: 93,
        // location: 87, commente by conflict with columnName
        tail_number: 88,
      }}
    >
      <PartRequestProvider>
        <PermissionsProvider resourceId={15}>
          <section className="part-request-main-cont store-part-request-component">
            <div
              className="part-request-top-section"
              style={{
                marginBottom: viewFilters ? "1rem" : "0",
              }}
            >
              <NavBar
                dataBreadCrumbs={"/store/part-request-management"}
                appIcon={"icon-part_request_icon"}
                moduleIcon={"icon-settings"}
                moduleColor="#6ac24f"
                title={"Part Request Management"}
                menuTitle={"Store Options"}
                moduleId={3}
                currentPath={"/store/new-part-request"}
                previousPath={"/store"}
                goBackData={goBackDataObj}
                screenActions={
                  <>
                    <ToggleViewButtons
                      tabView={value}
                      handlerTabsOptions={handleChangeToggle}
                    />
                  </>
                }
                isLocalSearch
                searchActions={
                  <>
                    <FiltersManager
                      appliedFilters={prnListBody}
                      onFilterChange={setPrnListBody}
                      handleClearAllFilters={clearFilters}
                      onClearGroup={(col) => filtersConfig[col]?.clearGroup?.()}
                      onDeleteFilter={(col, val) =>
                        filtersConfig[col]?.deleteValue?.(val)
                      }
                      getFilterLabel={(col) => filtersConfig[col]?.label || col}
                      getDisplayValue={(col, val) =>
                        filtersConfig[col]?.getDisplayValue(val) || val
                      }
                      onButtonClick={() => {
                        setViewFilters(!viewFilters);
                      }}
                      excludeColumns={["company_id", "status"]}
                    />
                    <SortingButton></SortingButton>
                  </>
                }
                searchInputProps={{
                  name: "search",
                  onTextChange:
                    value === 0 ? handleSearchOfPRN : handleSearchOfPRN,
                }}
              ></NavBar>
            </div>

            <div className="part-request-filters-container">
              <section
                className="part-request-filters"
                style={{
                  opacity: viewFilters ? 1 : 0,
                  visibility: viewFilters ? "visible" : "hidden",
                  height: viewFilters ? "9.5rem" : 0,
                }}
              >
                <section className="status-filters-cont">
                  <FormControl
                    sx={{
                      width: "100%",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: ".3rem",
                      background: "var(--white-100)",
                      borderRadius: "var(--item-border-radius)",
                      padding: ".4rem .5rem",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "calc(Var(--p-size) + .2rem)",
                        fontWeight: "500",
                        width: "7rem",
                      }}
                    >
                      Filter By Status
                    </p>
                    <FormGroup
                      aria-labelledby="demo-checkbox-buttons-group-label"
                      name="checkbox-buttons-group"
                      style={{
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <FormControlLabel
                        sx={{
                          ".css-rizt0-MuiTypography-root": {
                            fontSize: "calc(Var(--p-size) + .2rem)",
                            color: "var(--black-mid)",
                          },
                          background: "var(--white)",
                          borderRadius: "var(--button-radius)",
                          padding: "0 .3rem",
                          height: "2rem",
                          margin: "0",
                          width: "8rem",
                          gap: ".3rem",
                        }}
                        value="all"
                        control={
                          <Checkbox
                            sx={{ padding: "0" }}
                            checked={statusSelected.includes("all")}
                            indeterminate={
                              statusSelected.length > 0 &&
                              statusSelected.length < allOptions.length &&
                              !statusSelected.includes("all")
                            }
                            onChange={selectStatusFilter}
                          />
                        }
                        label={
                          <p
                            style={{
                              color: "var(--black-mid)",
                              fontSize: ".6rem",
                            }}
                          >
                            All
                          </p>
                        }
                      />

                      {individualOptions.map((option) => (
                        <FormControlLabel
                          key={option}
                          sx={{
                            ".css-rizt0-MuiTypography-root": {
                              fontSize: "calc(Var(--p-size) + .2rem)",
                              color: "var(--black-mid)",
                            },
                            background: "var(--white)",
                            borderRadius: "var(--button-radius)",
                            padding: "0 .3rem",
                            height: "2rem",
                            margin: "0",
                            width: option === "generation" ? "7rem" : "8rem",
                            gap: ".3rem",
                          }}
                          value={option}
                          control={
                            <Checkbox
                              sx={{ padding: "0" }}
                              checked={
                                statusSelected.includes(option) ||
                                statusSelected.includes("all")
                              }
                              onChange={selectStatusFilter}
                            />
                          }
                          label={
                            <p
                              style={{
                                color: "var(--black-mid)",
                                fontSize: ".6rem",
                              }}
                            >
                              {option.charAt(0).toUpperCase() + option.slice(1)}
                            </p>
                          }
                        />
                      ))}
                    </FormGroup>
                  </FormControl>
                </section>
                <div>
                  {
                    requestNumDrop ? (
                      <Dropdowns
                        handleClear={() => {
                          setRequestNumberSelected([]);
                          setPrnListBody((prevValue) => {
                            const updatedData = prevValue.filter(
                              (item) => item.columnName !== "id"
                            );

                            const companies =
                              JSON.parse(localStorage.getItem("u_companies")) ||
                              [];
                            const companiesId = companies.map((e) => e.id);

                            return [
                              {
                                columnName: "company_id",
                                value: companiesId,
                              },
                              ...updatedData,
                            ];
                          });
                        }}
                        onApplySelection={(e) => {
                          setRequestNumberSelected(e);
                          setRequestNumberPreselected(undefined);
                        }}
                        data={requestNumDrop}
                        preSelectValue={requestNumberPreselected} //RN
                      ></Dropdowns>
                    ) : (
                      <Skeleton height="2rem" width="80%" />
                    ) //RN
                  }
                </div>
                <div>
                  {
                    locationDropHierarchy ? (
                      <Dropdowns
                        handleClear={() => {
                          setLocationSelected([]);
                          setPrnListBody((prevValue) => {
                            const updatedData = prevValue.filter(
                              (item) => item.columnName !== "location"
                            );

                            const companies =
                              JSON.parse(localStorage.getItem("u_companies")) ||
                              [];
                            const companiesId = companies.map((e) => e.id);

                            return [
                              {
                                columnName: "company_id",
                                value: companiesId,
                              },
                              ...updatedData,
                            ];
                          });
                        }}
                        onApplySelection={(e) => {
                          setLocationSelected(e);
                          setLocationPreselected(undefined);
                        }}
                        data={locationDropHierarchy}
                        preSelectValue={locationPreselected} //locattions
                        optionsSelectedColumnName={"code"}
                      ></Dropdowns>
                    ) : (
                      <Skeleton height="2rem" width="80%" />
                    ) //locattions
                  }
                </div>

                <div>
                  {
                    aircraftDrop ? (
                      <Dropdowns
                        handleClear={() => {
                          setAircraftSelected([]);
                          setPrnListBody((prevValue) => {
                            const updatedData = prevValue.filter(
                              (item) => item.columnName !== "tail_number"
                            );

                            // Mantener siempre el filtro de company_id
                            const companies =
                              JSON.parse(localStorage.getItem("u_companies")) ||
                              [];
                            const companiesId = companies.map((e) => e.id);

                            return [
                              {
                                columnName: "company_id",
                                value: companiesId,
                              },
                              ...updatedData,
                            ];
                          });
                        }}
                        onApplySelection={(e) => {
                          setAircraftSelected(e);
                          setAircraftPreselected(undefined);
                        }}
                        data={aircraftDrop}
                        preSelectValue={aircraftPreselected}
                      ></Dropdowns>
                    ) : (
                      <Skeleton height="2rem" width="80%" />
                    ) // aircraft
                  }
                </div>
                <div>
                  {
                    WPDrop ? (
                      <Dropdowns
                        handleClear={() => {
                          setWPSelected([]);
                          setPrnListBody((prevValue) => {
                            const updatedData = prevValue.filter(
                              (item) => item.columnName !== "wp"
                            );

                            const companies =
                              JSON.parse(localStorage.getItem("u_companies")) ||
                              [];
                            const companiesId = companies.map((e) => e.id);

                            return [
                              {
                                columnName: "company_id",
                                value: companiesId,
                              },
                              ...updatedData,
                            ];
                          });
                        }}
                        onApplySelection={(e) => {
                          setWPSelected(e);
                          setWPPreselected(undefined);
                        }}
                        data={WPDrop}
                        preSelectValue={WPPreselected}
                      ></Dropdowns>
                    ) : (
                      <Skeleton height="2rem" width="80%" />
                    ) // aircraft
                  }
                </div>
                <div>
                  {
                    taskCardDrop ? (
                      <Dropdowns
                        handleClear={() => {
                          setTCSelected([]);
                          setPrnListBody((prevValue) => {
                            const updatedData = prevValue.filter(
                              (item) => item.columnName !== "tc"
                            );

                            const companies =
                              JSON.parse(localStorage.getItem("u_companies")) ||
                              [];
                            const companiesId = companies.map((e) => e.id);

                            return [
                              {
                                columnName: "company_id",
                                value: companiesId,
                              },
                              ...updatedData,
                            ];
                          });
                        }}
                        onApplySelection={(e) => {
                          setTCSelected(e);
                          setTCPreselected(undefined);
                        }}
                        data={taskCardDrop}
                        preSelectValue={TCPreselected} //task card
                        parameters={tcParameters}
                      ></Dropdowns>
                    ) : (
                      <Skeleton height="2rem" width="80%" />
                    ) //task card
                  }
                </div>
                <div>
                  {
                    FNDDrop ? (
                      <Dropdowns
                        handleClear={() => {
                          setFNDSelected([]);
                          setPrnListBody((prevValue) => {
                            const updatedData = prevValue.filter(
                              (item) => item.columnName !== "fnd"
                            );

                            const companies =
                              JSON.parse(localStorage.getItem("u_companies")) ||
                              [];
                            const companiesId = companies.map((e) => e.id);

                            return [
                              {
                                columnName: "company_id",
                                value: companiesId,
                              },
                              ...updatedData,
                            ];
                          });
                        }}
                        onApplySelection={(e) => {
                          setFNDSelected(e);
                          setFNDPreselected(undefined);
                        }}
                        data={FNDDrop}
                        preSelectValue={FNDPreselected}
                      ></Dropdowns>
                    ) : (
                      <Skeleton height="2rem" width="80%" />
                    ) // part number
                  }
                </div>

                <div>
                  {
                    partNumDrop ? (
                      <Dropdowns
                        handleClear={() => {
                          setPartNumberSelected([]);
                          setPrnListBody((prevValue) => {
                            const updatedData = prevValue.filter(
                              (item) => item.columnName !== "part_number_list"
                            );

                            const companies =
                              JSON.parse(localStorage.getItem("u_companies")) ||
                              [];
                            const companiesId = companies.map((e) => e.id);

                            return [
                              {
                                columnName: "company_id",
                                value: companiesId,
                              },
                              ...updatedData,
                            ];
                          });
                        }}
                        onApplySelection={(e) => {
                          setPartNumberSelected(e);
                          setPartNumberPreselected(undefined);
                        }}
                        data={partNumDrop}
                        preSelectValue={partNumberPreselected} // part number
                      ></Dropdowns>
                    ) : (
                      <Skeleton height="2rem" width="100%" />
                    ) // part number
                  }
                </div>
                <div
                  style={{
                    border: "none",
                    padding: "0",
                    gridColumn: "span 2",
                  }}
                >
                  <DateRangeComponent
                    label="Date Required"
                    getDateRange={handleDateRange}
                    resetRange={resetDateRange}
                  />
                </div>

                <div
                  style={{
                    border: "none",
                    padding: "0",
                    gridColumn: "span 2",
                  }}
                >
                  <DateRangeComponent
                    label="Date Requested Created"
                    getDateRange={handleDateRequestedRange}
                    resetRange={resetDateRange}
                  />
                </div>

                <div>
                  {
                    companyDrop && (
                      <Dropdowns
                        handleClear={() => {
                          setCompanySelected([]);
                          setPrnListBody((prevValue) => {
                            const updatedData = prevValue.filter(
                              (item) => item.columnName !== "company"
                            );

                            const companies =
                              JSON.parse(localStorage.getItem("u_companies")) ||
                              [];
                            const companiesId = companies.map((e) => e.id);

                            return [
                              {
                                columnName: "company_id",
                                value: companiesId,
                              },
                              ...updatedData,
                            ];
                          });
                        }}
                        isStatic={true}
                        staticData={companyDropData}
                        onApplySelection={(e) => {
                          setCompanySelected(e);
                          setCompanyPreselected(undefined);
                        }}
                        data={companyDrop}
                        preSelectValue={companyPreselected} // comapny
                      ></Dropdowns>
                    ) // comapny
                  }
                </div>
                <div>
                  {
                    customerDrop && (
                      <Dropdowns
                        handleClear={() => {
                          setCustomerSelected([]);
                          setPrnListBody((prevValue) => {
                            const updatedData = prevValue.filter(
                              (item) => item.columnName !== "customer"
                            );

                            const companies =
                              JSON.parse(localStorage.getItem("u_companies")) ||
                              [];
                            const companiesId = companies.map((e) => e.id);

                            return [
                              {
                                columnName: "company_id",
                                value: companiesId,
                              },
                              ...updatedData,
                            ];
                          });
                        }}
                        onApplySelection={(e) => {
                          setCustomerSelected(e);
                          setCustomerPreselected(undefined);
                        }}
                        data={customerDrop}
                        preSelectValue={customerPreselected} //customer
                      ></Dropdowns>
                    ) //customer
                  }
                </div>
                <button
                  className="btn-clear-all-filters-prnManagement"
                  onClick={clearFilters}
                >
                  Clear All Filters
                </button>
              </section>

              <hr />
            </div>

            <div className={`part-request-header-cont ${value == 0 ? "" : ""}`}>
              <div className="part-request-header">
                <div className="part-request-availability">
                  <span>
                    <div
                      className="indicator"
                      style={{
                        background: "#00ce88",
                      }}
                    >
                      <i className="icon-success"></i>
                    </div>{" "}
                    <p>All parts Available</p>
                  </span>
                  <span>
                    <div
                      className="indicator"
                      style={{
                        background: "var(--yellow-100)",
                      }}
                    >
                      <i className="icon-warning"></i>
                    </div>{" "}
                    <p>Some Parts Availables</p>
                  </span>
                  <span>
                    <div
                      className="indicator"
                      style={{
                        background: "var(--red-50)",
                      }}
                    >
                      <i className="icon-error"></i>
                    </div>{" "}
                    <p>No parts Availables</p>
                  </span>
                  <span>
                    <div
                      className="indicator"
                      style={{
                        background: "var(--blue-300)",
                      }}
                    >
                      <i className="icon-issued"></i>
                    </div>{" "}
                    <p>Issued</p>
                  </span>
                </div>
              </div>
              <DropdownsProvider>
                {hasPermissionsToCreate && (
                  <ButtonCreateOrEmit value={value}></ButtonCreateOrEmit>
                )}
              </DropdownsProvider>
              {/* <div className="part-request-header-cont-left">
                <b>Search</b>

                <div className="search-bar-input">
                  {value == 0 ? (
                    <Input
                      placeholder={"Search"}
                      name={"search"}
                      onChange={handleSearchOfPRN}
                    ></Input>
                  ) : (
                    <SearchBarContainer />
                  )}
                  <i className="icon-search"></i>
                </div>
                <ToggleViewButtons
                  tabView={value}
                  handlerTabsOptions={handleChangeToggle}
                />
              </div>

              <DropdownsProvider>
                {hasPermissionsToCreate && (
                  <ButtonCreateOrEmit value={value}></ButtonCreateOrEmit>
                )}
              </DropdownsProvider>
              <span style={{

                marginLeft: "auto"
              }}>
                <FiltersManager
                  appliedFilters={prnListBody}
                  onFilterChange={setPrnListBody}
                  handleClearAllFilters={clearFilters}
                  onClearGroup={(col) => filtersConfig[col]?.clearGroup?.()}
                  onDeleteFilter={(col, val) => filtersConfig[col]?.deleteValue?.(val)}
                  getFilterLabel={(col) => filtersConfig[col]?.label || col}
                  getDisplayValue={(col, val) => filtersConfig[col]?.getDisplayValue(val) || val}
                  onButtonClick={() => { setViewFilters(!viewFilters) }}
                  excludeColumns={["company_id", "status"]}

                />
              </span>
              <SortingButton></SortingButton> */}
            </div>
            {value == 0 && (
              <div
                className={`part-request-list-cont ${
                  typeRequestTab === "Workpackage"
                    ? "wp"
                    : typeRequestTab === "Transfer"
                    ? "Transfer"
                    : ""
                }`}
                style={{
                  height: viewFilters ? "60%" : "84%",
                  borderBottom: viewFilters ? "none" : "1px solid #efefef",
                }}
              >
                <section className="prn-hierarchy-tabs-btn">
                  <button
                    style={{
                      background:
                        typeRequestTab == "Workpackage"
                          ? "var(--black-mid)"
                          : "var(--white)",
                      color:
                        typeRequestTab == "Workpackage"
                          ? "var(--white)"
                          : "var(--black-mid)",
                    }}
                    onClick={() => setTypeRequestTab("Workpackage")}
                  >
                    Workpackage <span>{countWPRequest}</span>
                  </button>
                  <button
                    style={{
                      background:
                        typeRequestTab == "Transfer"
                          ? "var(--black-mid)"
                          : "var(--white)",
                      color:
                        typeRequestTab == "Transfer"
                          ? "var(--white)"
                          : "var(--black-mid)",
                    }}
                    onClick={() => setTypeRequestTab("Transfer")}
                  >
                    Transfer <span>{countTransferRequest}</span>
                  </button>
                </section>
                <SortingHeader
                  showHeaderOrder={true}
                  valuesExtractor={{
                    id: (items) => items.map((i) => i.id),
                    wp: (items) => items.map((i) => i.id),
                    location: (items) => items.map((i) => i.id),
                    tail_number: (items) => items.map((i) => i.tail_number),
                  }}
                  onFiltersSelected={(newFiltersArray, fullSelectedMap) => {
                    handleFiltersSortingChange(fullSelectedMap);
                  }}
                />
                <section
                  style={{
                    position: "relative",
                  }}
                  ref={sectionPartListRef}
                >
                  {loading && visualizeSkeletonLoading ? (
                    <Skeleton count={8} height="2.7rem" />
                  ) : partList.length > 0 ? (
                    partList.map((part, idx) => (
                      <PartRequestItem
                        key={idx}
                        idx={idx}
                        itemOpened={itemPartRequestOpened}
                        emitItemOpened={getItemOpened}
                        initialData={part}
                        reload={getPartRequest}
                      />
                    ))
                  ) : (
                    <ResultsNotFound />
                  )}
                </section>
              </div>
            )}

            {value == 1 && <PartRequestTabularView></PartRequestTabularView>}
          </section>
        </PermissionsProvider>
      </PartRequestProvider>
    </SortingProvider>
  );
};

const NavBarContainer = ({ ...props }) => {
  // const { setSortingOrder, onSearch } = useContext(TypeSeriesConfigurationCxt);
  return (
    <NavBar
      searchInputProps={{
        // onTextChange: (e) => onSearch(e)
        onTextChange: (e) => console.warn(e),
      }}
      {...props}
    />
  );
};
